import definitions from '../../data.js';
import * as node from '../node/index.js';

export default {
    generic: true,
    ...definitions,
    node
};
